import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {
  SystemButtonModule,
  SystemButtonOutlineModule,
  SystemCheckboxModule,
  SystemIconComponentModule,
  SystemInputTextModule,
  SystemLabelModule,
  SystemSelectModule,
} from '@app/shared/ui-components';
import { InputSetComponent } from './input-set.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SignatureModalModule } from '../../organisms';

@NgModule({
  declarations: [InputSetComponent],
  exports: [InputSetComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgOptimizedImage,
    SystemCheckboxModule,
    SystemInputTextModule,
    SystemLabelModule,
    SystemSelectModule,
    SystemIconComponentModule,
    SystemButtonModule,
    SystemButtonOutlineModule,
    SignatureModalModule,
  ],
})
export class SystemInputSetModule {}
